App.Models.UnpaidRemittance = BackboneEx.Model.Silent.extend({
  url: function () {
    return App.Api.wsUrl(
      `/supplier/${App.config.get('venue').supplierId}/overdue-remittances.json`,
    );
  },
});
